import styled from 'styled-components';
import BundlePrice from '../../BundlePrice';
import BundleProduct from '../BundleProduct';
import { BundleProps } from '../../types';
import { BadgeData } from '../../../Badge/types';
import { createGradientOrSolid } from '../../../Helper/utils';
import { EBundleDesign } from '../../../Helper/enums';
import Badge from '../../../Badge/CornerBadge';

const StyledBundle = styled.div`
    display: flex;
    justify-content: center;
    align-items: flex-start;
    aspect-ratio: 2/1;
    font-family: ${(props: any) => props.fontFamily};
    position: relative;
    border-radius: 20px;
    padding: 4px;
    background: ${(props: any) =>
        createGradientOrSolid(props.bundleBorderColor)};
    margin: 0 auto;
    min-height: 100px;
    width: calc(100% - 16px);
    display: flex;
    justify-content: center;
    align-items: flex-start;
    font-size: 24px;
    position: relative;
` as any;

const StyledContainer = styled.div`
    height: calc(100% - 32px);
    width: 100%;
    border-radius: 15px;
    overflow: hidden;
    background: ${(props: any) =>
        props.backgroundSrc
            ? `url("${props.backgroundSrc}")`
            : createGradientOrSolid(props.backgroundColor)};
    background-position: 50% 50%;
    background-size: cover;
    display: flex;
    justify-content: center;
    align-items: center;
` as any;

const StyledProducts = styled.div<{ numberOfProducts: number }>`
    display: flex;
    flex-direction: row;
    gap: ${(props: any) => `${1.4 - 0.2 * props.numberOfProducts}em`};
`;

const StyledButtonContainer = styled.div`
    position: absolute;
    bottom: 12px;
    left: 50%;
    z-index: 2;
    transform: translateX(-50%);
`;

const StyledLowerPart = styled.div`
    width: 100%;
    height: 30px;
    display: flex;
    flex-direction: row;
    font-size: 11px;
    justify-content: space-between;
    align-items: flex-end;
    position: absolute;
    bottom: 4px;
    div {
        display: inline-block;
        padding: 0 1em;
        text-shadow: 1px 1px 0 black, -1px -1px 0 black, 1px -1px 0px black,
            -1px 1px 0 black;
        span {
            margin: 0;
            color: #ffffff;
            font-size: 1em;
            letter-spacing: 0.02em;
            font-weight: 400;
            line-height: 1.43;
        }
    }
`;


function Bundle({
    backgroundSrc,
    backgroundColor = {colorOne: "#000088"},
    price = {
        price: 100,
        currencySymbol: '$',
        isCents: true,
        symbolPosition: 'right',
        fractionalSeparator: '.',
        milSeparator: ',',
        spacing: false,
        currencyCode: 'usd'
    },
    availability,
    playerAvailability,
    productList = [
        {
            textFontColorHex: '#ffabff',
            images: {product: 'https://animal-kingdom-media.s3.amazonaws.com/asset-2.png?a=a'},
            quantity: 100,
            prefix: '',
            suffix: ''
        },
        {
            textFontColorHex: '#ffe060',
            images: {product: 'https://animal-kingdom-media.s3.amazonaws.com/asset-2.png?a=a'},
            quantity: 50000,
            prefix: '',
            suffix: ''
        },
        {
            textFontColorHex: '#60d9ff',
            images: {product: 'https://animal-kingdom-media.s3.amazonaws.com/asset-2.png?a=a'},
            quantity: 80,
            prefix: '',
            suffix: ''
        }
    ],
    bundleBorderColor,
    bundleButtonColor,
    bundleButtonTextColor,
    fontFamily,
    badges = [],
}: BundleProps) {
    return (
        <StyledBundle
            bundleBorderColor={bundleBorderColor}
            fontFamily={fontFamily}
        >
            <StyledContainer backgroundSrc={backgroundSrc} backgroundColor={backgroundColor}>
                <StyledProducts numberOfProducts={productList.length}>
                    {productList.map((product, i) => {
                        return (
                            <BundleProduct
                                prefix={product.prefix}
                                suffix={product.suffix}
                                textFontColorHex={product.textFontColorHex}
                                images={product.images}
                                quantity={product.quantity}
                                key={i}
                            />
                        );
                    })}
                </StyledProducts>
            </StyledContainer>
            <StyledButtonContainer>
                <BundlePrice
                    price={price}
                    buttonColor={bundleButtonColor}
                    buttonTextColor={bundleButtonTextColor}
                    type={EBundleDesign.AK}
                    borderRadius="18px"
                />
            </StyledButtonContainer>
            {
                badges.map((badge: BadgeData, i: number) => 
                    <Badge
                        {...badge}
                        key={i}
                    />
                )
            }
        </StyledBundle>
    );
}

export default Bundle;
